import type { BestaetigeNutzerEmailRequest, IsConfirmationTokenValidRequest, Nutzer } from '@/js/model'

const TOKEN_STORAGE_KEY = 'hoop-token' as const
const USER_IRI_STORAGE_KEY = 'hoop-user-iri' as const
const ORIGIN_USER_IRI_STORAGE_KEY = 'hoop-user-origin-iri' as const

export const useAuthStore = defineStore('auth', () => {
    const loginService = useLoginService()
    const nutzerService = useNutzerService()
    const router = useRouter()

    const token = useLocalStorage(TOKEN_STORAGE_KEY, '')
    const currentUserIri = useLocalStorage(USER_IRI_STORAGE_KEY, '')
    const originUserIri = useLocalStorage(ORIGIN_USER_IRI_STORAGE_KEY, '')
    const currentUser = ref<Nutzer | null>(null)
    const isAuthenticated = computed(() => !!token.value && !!currentUserIri.value)
    const currentUserRoles = computed(() => determineRoles((currentUser.value as any)?.rollen))
    const isUserSwitched = computed(() => !!originUserIri.value)

    // const hasRole = (role: RollenName): boolean => currentUserRoles.value.includes(role)

    const { isLoading, isMethodLoading, loadingMethods, setLoading } = useLoading()

    const login = async (body: { username: string; password: string }) => {
        await setLoading('login', async () => {
            const result = await loginService.login(body)

            token.value = result.token
            currentUserIri.value = result['@id']

            await fetchCurrentUser()
        })
    }

    const logout = () => {
        setLoading('logout', async () => {
            token.value = null
            currentUserIri.value = null
            originUserIri.value = null

            console.log('here');
            isUserSwitched.value ? exitUserSwitch() : window.location.reload()
            console.log('here2');
        })
    }

    const fetchCurrentUser = async (): Promise<void> => {
        await setLoading('fetchCurrentUser', async () => {
            currentUser.value = await nutzerService.getNutzerByIri(currentUserIri.value)
        })
    }

    const isConfirmationTokenValid = async (request: IsConfirmationTokenValidRequest): Promise<void> => {
        await setLoading('isConfirmationTokenValid', async () => {
            await nutzerService.isConfirmationTokenValid(request)
        })
    }

    const bestaetigeNutzerEmail = async (request: BestaetigeNutzerEmailRequest): Promise<Nutzer> => {
        return await setLoading('bestaetigeNutzerEmail', async () => {
            const nutzer = await nutzerService.bestaetigeNutzerEmail(request)
            currentUser.value = nutzer;

            return nutzer
        })
    }

    const switchUser = (newUser: Nutzer): void => {
        setLoading('switchUser', async () => {
            originUserIri.value = currentUserIri.value
            currentUserIri.value = newUser['@id'] as string

            router.go(0)
        })
    }

    const exitUserSwitch = (): void => {
        setLoading('exitUserSwitch', async () => {
            currentUserIri.value = originUserIri.value
            originUserIri.value = null

            router.go(0)
        })
    }

    return {
        loadingMethods,
        isMethodLoading,
        currentUser,
        currentUserRoles,
        exitUserSwitch,
        fetchCurrentUser,
        isAuthenticated,
        isLoading,
        isUserSwitched,
        login,
        logout,
        switchUser,
        token,
        bestaetigeNutzerEmail,
        isConfirmationTokenValid
    }
})
